import React from "react";
import { Menu, MenuProps } from "@mui/material";

const TrailerMenu = (props: { position: "left" | "right" } & MenuProps) => {
  const { position, children } = props;
  const alignment = position === "left" ? { left: 14 } : { right: 14 };

  return (
    <Menu
      {...props}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              ...alignment,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        },
      }}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      disableScrollLock={true}
      data-cy="nav-user-menu"
    >
      {children}
    </Menu>
  );
};

export default TrailerMenu;
